export default "__VITE_ASSET__DFcQlws4__"